import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { Button } from '@dojo/widgets/button';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import { Icon } from '@holmescorp/base-widgets';
import css from '../css/card-button.m.css';
const factory = create({
    theme
}).properties();
export const MicroCardButton = factory(({ id, properties, middleware: { theme } }) => {
    const { key, xqa, labelText = '', showIcon = true, iconPosition = 'after', icon, aria = {}, disabled = false, name, onBlur, onClick, onDown, onFocus, widgetId = `button-${id}`, title = '', darkMode = false, additionalClasses = [] } = properties();
    const fixedCss = theme.classes(css);
    const label = v('span', {}, [labelText]);
    const buttonIcon = icon || w(Icon, { faname: 'arrow-right-long' });
    const overrides = {
        '@dojo/widgets/button': {
            root: [fixedCss.root],
            text: [fixedCss.text],
            contained: [fixedCss.contained],
            outlined: [fixedCss.outlined],
            popup: [fixedCss.popup],
            label: [fixedCss.label],
            icon: [fixedCss.icon],
            iconOnly: [fixedCss.iconOnly],
            disabled: [fixedCss.disabled]
        }
    };
    return v('div', { xqa, classes: [...additionalClasses, fixedCss.root, darkMode ? fixedCss.dark : null] }, [
        w(Button, {
            key,
            classes: overrides,
            ...formatAriaProperties(aria),
            disabled,
            name,
            onBlur,
            onClick,
            onDown,
            onFocus,
            widgetId,
            title,
            iconPosition
        }, [
            {
                label,
                icon: showIcon ? buttonIcon : undefined
            }
        ])
    ]);
});
export default MicroCardButton;
